import React from 'react'
import { initializeApollo } from 'gql/client'
import { PAGINA } from 'utils/queries'
import ChiamaciTemplate from '@components/templates/ChiamaciTemplate/ChiamaciTemplate'
import { NextWrapper } from 'data-fetching-wrapper'

const ChiamaciPage = ({ pagina }) => <ChiamaciTemplate pagina={pagina} />

export const getStaticProps = NextWrapper.getStaticProps(async () => {
  const client = initializeApollo()

  const {
    data: { pagina },
  } = await client.query({
    query: PAGINA,
    variables: { chiave: 'chiamaci' },
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  return {
    props: { pagina },
    revalidate: 60 * 2,
  }
}, '/chiamaci')

export default ChiamaciPage
